import nodes from './nodes';
import systemEdges from './edges';
import groups from './groups';


const dependencyEdges = nodes
  .filter(node => node.data.dependency)
  .map(node => ({
    data: {
      source: node.data.id,
      target: node.data.dependency
    }
}))

export default { 
  groups,
  elements: { 
    nodes, 
    edges: systemEdges.concat(dependencyEdges)
    }
};
